import { Controller, useForm } from 'react-hook-form';
import { useSearchParams } from 'react-router-dom';
import {
  Collapse,
  Card,
  Grid,
  TextField,
} from '@mui/material';
import { TableFilterButtons } from '../../../../common/TableFilterButtons';

export function ModulesTableFilter({ isOpenFilters, isLoadingList, empresas }) {
  const [searchParams, setSearchParams] = useSearchParams()

  const titulo = searchParams.get('titulo');
  const perPage = searchParams.get('perPage');

  const { handleSubmit, reset, control } = useForm({
    defaultValues: {
      titulo: titulo ?? '',
    },
  });

  function handleSubmitFilter(data) {
    for (const key in data) {
      // remove campos vazios
      if (data[key] === '') {
        delete data[key];
      }
    }

    const queryFilters = {
      ...data,
      page: '1',
      perPage: perPage ?? '10'
    }

    // fill url params with filters
    setSearchParams(queryFilters);
  }

  return (
    <Grid item xs={12} component="form" onSubmit={handleSubmit(handleSubmitFilter)}>
      <Collapse in={isOpenFilters}>
        <Card variant="outlined" sx={{ padding: 2 }}>
          <Grid container spacing={2}>
            <Grid item xs={12} md={4}>
              <Controller
                name="titulo"
                control={control}
                defaultValue=""
                render={({ field }) => (
                  <TextField
                    label="Título do Módulo"
                    fullWidth
                    size="small"
                    {...field}
                  />
                )}
              />
            </Grid>

            <TableFilterButtons
              isLoading={isLoadingList}
              handleClearFilters={() => {
                setSearchParams((state) => {
                  state.delete('titulo')
                  state.set('page', '1')

                  return state
                })

                reset({
                  titulo: '',
                });
              }}
            />
          </Grid>
        </Card>
      </Collapse>
    </Grid>
  );
}
